import { render, staticRenderFns } from "./OnlineStores.vue?vue&type=template&id=671674fc"
import script from "./OnlineStores.vue?vue&type=script&lang=js"
export * from "./OnlineStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports